import lessRequire from '../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';

lessRequire('modules/shared/progress-bar.less');

export default class ProgressBar extends React.Component {
	constructor(props) {
		super(props);
		const initialState = {
			showProgressBar: false,
			timeout: null,
			isEveradProgressBar: process.env.CPA_ENV == 'everad',
			bulletsOffset: '35%',
			containerStyle: {
				height: '100%',
				width: '100%',
				margin: 'auto'
			}
		};

		let footerHeight = 430;
		let $prevContent = document.querySelector('.dashboard-layout__content');

		if (initialState.isEveradProgressBar) {
			if ($prevContent) {
				initialState.containerStyle.height = $prevContent.clientHeight - footerHeight;
				initialState.bulletsOffset = '200px';
			} else if (!this.props.isAppInitProgressBar) {
				initialState.bulletsOffset = '100px';
			}
		} else if (!this.props.isAppInitProgressBar) {
			// reset to less for rocket progressbar
			initialState.containerStyle = null;
			initialState.bulletsOffset = '40%';
		}

		this.state = { ...initialState };
	}
	componentDidMount() {
		let timeout = setTimeout(() => {
			if (this.state.isEveradProgressBar) {
				const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
				const topHeight = getElementHeightByClassname('header-top');
				const navHeight = getElementHeightByClassname('header-nav');
				const footerHeight = getElementHeightByClassname('footer-top');
				let minHeight = viewportHeight - topHeight - navHeight - footerHeight - 30;
				minHeight = minHeight < 250 ? 250 : minHeight;
				this.setState({ containerStyle: { ...this.state.containerStyle, 'minHeight': `${minHeight}px` } });
			}
			this.setState({ showProgressBar: true });
		}, 200);
		this.setState({ timeout });
	}
	componentWillUnmount() {
		this.state.timeout && clearTimeout(this.state.timeout);
	}
	render() {
		return (
			<div className="progress-bar" style={this.state.containerStyle}>
				{this.state.showProgressBar ? (
					<ul className="progress-bar__bullets" style={{ top: this.state.bulletsOffset }}>
						<li />
						<li />
						<li />
					</ul>
				) : null}
			</div>
		);
	}
}

ProgressBar.propTypes = {
	isAppInitProgressBar: PropTypes.bool
};

const getElementHeightByClassname = classname => {
	let elements = document.getElementsByClassName(classname);
	if (!elements || !elements.length) {
		return 0;
	}
	return elements[0].offsetHeight;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/progress-bar.js